<template>
    <v-form @submit.prevent="addUpdate" ref="form">
        <v-card class="rounded-4">
            <v-toolbar flat height="55px">
                <span class="font-weight-bold">{{mode}} Pay Grade</span>
                <v-spacer></v-spacer>
                <help-link appId="compensation" pageId="pay-grade" color="black"></help-link>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                Error encountered. Please contact support. Error details: {{errorMessage}}
            </v-alert>  
            <v-card-text>
                <v-layout row wrap> 
                    <v-flex xs12 sm4 class="form-content">                
                        <v-text-field label="Code" 
                            v-model="code" 
                            :disabled="disabled"
                            :rules="[rules.required]"
                            hint="Sample P1, M2"
                            ></v-text-field>  
                    </v-flex>
                    <v-flex xs12 sm8 class="form-content">
                        <v-select
                            label="Role"
                            :items="paygrade_roles"
                            :rules="[rules.required]" 
                            item-text="role"
                            item-value="role"
                            :disabled="disabled"
                            v-model="role"          
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row wrap> 
                    <v-flex xs12 class="form-content">   
                        <v-card class="elevation-0"> 
                            <v-toolbar flat height="35px">
                                <span class="font-weight-bold ">Monthly Basic Salary Range (₱)</span>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-card-text>
                                <v-layout row wrap> 
                                    <v-flex xs12 sm6>                
                                        <v-text-field label="From" 
                                            v-model="salaryStart" 
                                            :disabled="disabled"
                                            :rules="[rules.required]"
                                            type="number"
                                            ></v-text-field>  
                                    </v-flex>
                                    <v-flex xs12 sm6>                
                                        <v-text-field label="To" 
                                            v-model="salaryEnd" 
                                            :disabled="disabled"
                                            type="number"
                                            :rules="[rules.required]"
                                            ></v-text-field>  
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-layout row wrap v-if="showComment"> 
                    <v-flex xs12 sm12 class="form-content">
                        <v-textarea v-model="description" label="Description" rows="1" color="primary"></v-textarea> 
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon @click="showComment=!showComment" title="Add Comment">
                    <v-icon>comment</v-icon>
                </v-btn>
                <v-btn v-if="mode!='Update'" @click="clearForm" :disabled="disabled">Clear</v-btn>
                <v-btn color="primary" type="submit" :disabled="disabled" :loading="loading" dark class="mr-25">{{mode}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import payGradeApi from '@/api/paygrade'

export default {
    data () {
        return {
            email: null,
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
            rules: {
                required: value => !!value || 'Required field',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },
            paygrade_roles: [
                {role: 'Rank and File'},
                {role: 'Supervisory'},
                {role: 'Managerial'}
            ],         
            showComment: false,
            job_grade: null,
            mode: null,
            payGradeId: 0,
            code: null,
            role: null,
            description: "",
            salaryStart: null,
            salaryEnd: null,
        }
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    methods: {
        formatNumber() {
            this.salaryStart = Number(this.salaryStart).toLocaleString('en');
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        setAdd() {
            this.mode = 'Add'
            this.clearForm()
        },
        setUpdate(data) {
            this.mode = 'Update'
            this.payGradeId = data.payGradeId
            this.code = data.code
            this.role = data.role
            this.description = data.description
            this.salaryStart = data.salaryStart
            this.salaryEnd = data.salaryEnd
        },
        async addUpdate() {
            try {
                this.loading = true
                this.disabled = true

                if (this.$refs.form.validate()) {
                    var data = {
                        payGradeId: this.payGradeId,
                        code: this.code,
                        role: this.role,
                        description: this.description,
                        salaryStart: this.salaryStart,
                        salaryEnd: this.salaryEnd
                    }

                    var response = null
                    if (this.mode == 'Add')
                        response = await payGradeApi.add(data)
                    else
                        response = await payGradeApi.update(data)
                        
                    if (response.status == 200) {
                        this.closeDialog()
                        this.$emit('send', true)
                    }
                }

                this.loading = false
                this.disabled = false
            }
            catch (error) {
                this.loading = false
                this.disabled = false
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialogAddEdit', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
            this.errorMessage = ''
        },
    },
    computed: {},
    created() {}
}
</script>
<style scoped>
.form-content {
    padding: 0px 20px 0px 20px;
}
</style>